import { render, staticRenderFns } from "./SearchAccount.vue?vue&type=template&id=2f680890&scoped=true"
import script from "./SearchAccount.vue?vue&type=script&lang=js"
export * from "./SearchAccount.vue?vue&type=script&lang=js"
import style0 from "./SearchAccount.vue?vue&type=style&index=0&id=2f680890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f680890",
  null
  
)

export default component.exports